const errorData = {
  firstNameError: 'Please enter a valid legal first name',
  lastNameError: 'Please enter a valid legal last name',
  dateOfBirthError: 'Please enter a valid date of birth',
  phoneNumberError: 'Please enter a valid phone number',
  emailError: 'Please enter valid email',
  storeNumberError: 'Please enter valid store number',
  prescriptionNumberError: 'Please enter valid prescription number',
};

const govFundedOptions = [
  {
    value: 'Yes',
    label: 'Yes',
  },
  {
    value: 'No',
    label: 'No',
  },
];

const hipaaConsentOptions = [
  {
    value: 'accept',
    label:
      'Yes, send me personalized offers and savings on groceries and services.',
  },
  {
    value: 'decline',
    label: 'No, I do not wish to receive pharmacy rewards and coupons.',
  },
];

const bannerObj = [
  {
    logo: 'albertsons.png',
    favIcon: 'albertsonsicon.png',
    logoLink: 'https://www.albertsons.com/account/short-registration.html',
    heroText: 'Albertsons',
    homePageLink: 'https://www.albertsons.com',
    pharmacyLink: 'https://www.albertsons.com/pharmacy.html',
    bannerName: 'albertsons',
    email: 'web.comments@albertsons.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'acme.png',
    favIcon: 'acmeicon.png',
    logoLink: 'https://www.acmemarkets.com/account/short-registration.html',
    heroText: 'Acme',
    homePageLink: 'https://www.acmemarkets.com/',
    pharmacyLink: 'https://www.acmemarkets.com/pharmacy.html',
    bannerName: 'acmemarkets',
    email: 'web.comments@acmemarkets.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'albertsonsmarket.png',
    favIcon: 'albertsonsicon.png',
    logoLink: 'https://www.albertsonsmarket.com/rs/signup',
    heroText: 'Albertsons Market',
    homePageLink: 'https://www.albertsonsmarket.com',
    pharmacyLink: '',
    bannerName: 'albertsonsmarket',
    email: '',
    phoneNumber: '',
  },
  {
    logo: 'amigos.png',
    favIcon: 'amigosicon.png',
    logoLink: 'https://www.amigosunited.com/rs/Signup',
    heroText: 'Amigos',
    homePageLink: 'https://www.amigosunited.com',
    pharmacyLink: '',
    bannerName: 'amigosunited',
    email: '',
    phoneNumber: '',
  },
  {
    logo: 'carrs.png',
    favIcon: 'safewaysicon.png',
    logoLink: 'https://www.carrsqc.com/account/short-registration.html',
    heroText: 'Carrs',
    homePageLink: 'https://www.carrsqc.com',
    pharmacyLink: 'https://www.carrsqc.com/pharmacy.html',
    bannerName: 'carrsqc',
    email: 'web.comments@safeway.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'haggen.png',
    favIcon: 'haggenicon.png',
    logoLink: 'https://www.haggen.com/?s=signup',
    heroText: 'Haggen',
    homePageLink: 'https://www.haggen.com/',
    pharmacyLink: '',
    bannerName: 'haggen',
    email: 'web.comments@haggen.com',
    phoneNumber: '800-995-1902',
  },
  {
    logo: 'jewelosco.png',
    favIcon: 'jeweloscoicon.png',
    logoLink: 'https://www.jewelosco.com/account/short-registration.html',
    heroText: 'Jewel-Osco',
    homePageLink: 'https://www.jewelosco.com',
    pharmacyLink: 'https://www.jewelosco.com/pharmacy.html',
    bannerName: 'jewelosco',
    email: 'web.comments@jewelosco.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'lucky.png',
    favIcon: 'luckyicon.png',
    logoLink: 'https://www.luckysupermarkets.com/user_info/login',
    heroText: 'Lucky',
    homePageLink: 'https://www.luckysupermarkets.com',
    pharmacyLink: '',
    bannerName: 'luckysupermarkets',
    email: '',
    phoneNumber: '',
  },
  {
    logo: 'marketstreet.png',
    favIcon: 'marketstreeticon.png',
    logoLink: 'https://www.marketstreetunited.com/rs/Signup',
    heroText: 'Market Street',
    homePageLink: 'https://www.marketstreetunited.com',
    pharmacyLink: '',
    bannerName: 'marketstreetunited',
    email: '',
    phoneNumber: '',
  },
  {
    logo: 'paknsave.png',
    favIcon: 'safewaysicon.png',
    logoLink: 'https://www.safeway.com/account/short-registration.html ',
    heroText: 'Pak N Save',
    homePageLink: 'https://www.safeway.com',
    pharmacyLink: 'https://www.safeway.com/pharmacy.html',
    bannerName: 'paknsave',
    email: 'web.comments@safeway.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'pavilions.png',
    favIcon: 'pavilionsicon.png',
    logoLink: 'https://www.pavilions.com/account/short-registration.html',
    heroText: 'Pavilions',
    homePageLink: 'https://www.pavilions.com',
    pharmacyLink: 'https://www.pavilions.com/pharmacy.html',
    bannerName: 'pavilions',
    email: 'web.comments@pavilions.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'shaws.png',
    favIcon: 'shawsicon.png',
    logoLink: 'https://www.shaws.com/account/short-registration.html',
    heroText: 'Shaws',
    homePageLink: 'https://www.shaws.com/',
    pharmacyLink: 'https://www.shaws.com/pharmacy.html',
    bannerName: 'shaws',
    email: 'web.comments@shaws.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'starmarket.png',
    favIcon: 'starmarketicon.png',
    logoLink: 'https://www.starmarket.com/account/short-registration.html',
    heroText: 'Star Market',
    homePageLink: 'https://www.starmarket.com/',
    pharmacyLink: 'https://www.starmarket.com/pharmacy.html',
    bannerName: 'starmarket',
    email: 'web.comments@starmarket.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'tomthumb.png',
    favIcon: 'tomthumbicon.png',
    logoLink: 'https://www.tomthumb.com/account/short-registration.html',
    heroText: 'Tom Thumb',
    homePageLink: 'https://www.tomthumb.com/',
    pharmacyLink: 'https://www.tomthumb.com/pharmacy.html',
    bannerName: 'tomthumb',
    email: 'web.comments@tomthumb.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'unitedsupermarkets.png',
    favIcon: 'unitedsupermarketsicon.png',
    logoLink: 'https://www.unitedsupermarkets.com/rs/Signup',
    heroText: 'United',
    homePageLink: 'https://www.unitedsupermarkets.com',
    pharmacyLink: '',
    bannerName: 'unitedsupermarkets',
    email: '',
    phoneNumber: '',
  },
  {
    logo: 'safeways.png',
    favIcon: 'safewaysicon.png',
    logoLink: 'https://www.safeway.com/account/short-registration.html',
    heroText: 'Safeway',
    homePageLink: 'https://www.safeway.com',
    pharmacyLink: 'https://www.safeway.com/pharmacy.html',
    bannerName: 'safeway',
    email: 'web.comments@safeway.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'randalls.png',
    favIcon: 'randallsicon.png',
    logoLink: 'https://www.randalls.com/account/short-registration.html',
    heroText: 'Randalls',
    homePageLink: 'https://www.randalls.com/',
    pharmacyLink: 'https://www.randalls.com/pharmacy.html',
    bannerName: 'randalls',
    email: 'web.comments@randalls.com',
    phoneNumber: '877-723-3929',
  },
  {
    logo: 'vons.png',
    favIcon: 'vonsicon.png',
    logoLink: 'https://www.vons.com/account/short-registration.html',
    heroText: 'Vons',
    homePageLink: 'https://www.vons.com/',
    pharmacyLink: 'https://www.vons.com/pharmacy.html',
    bannerName: 'vons',
    email: 'web.comments@vons.com',
    phoneNumber: '877-723-3929',
  },
];

const incentivePageHeading = {
  prescriptionHeading:
    ' Thank you for filling your prescription! In order to verify your coupon eligibility, please provide the following information as it appears on your prescription:',
  immunizationHeading:
    ' Thank you for getting your immunization! In order to verify your coupon eligibility, please provide the following information as it appears on your prescription:',
};

const uniqueOfferIds = [
  { value: 1, coupon: 'old $25' },
  { value: 2, coupon: 'old $50' },
  { value: 3, coupon: 'clac 20%' },
  { value: 4, coupon: 'new $25' },
  { value: 5, coupon: 'new $50' },
  { value: 6, coupon: 'rec 20%' },
  { value: 7, coupon: 'new $25' },
  { value: 8, coupon: '20%' },
  { value: 9, coupon: '10%' },
  { value: 0, coupon: 'others' },
];

const HIPAA_DECLINE = 'hipaa-decline';
const hipaaDeclineNotification = {
  heading: 'You declined the HIPPA marketing authorization',
  body: 'In order to check eligibility for offers, you must agree to our marketing consent. If you declined in error, you can always enter your information again, then accept the marketing authorization.',
};

const appDownloadLinks = {
  acmemarkets:
    'https://acme.onelink.me/8yDm?af_web_dp=http://www.acmemarkets.com/health.html',
  albertsons:
    'https://albertsons.onelink.me/eT3h?af_web_dp=http://www.albertsons.com/health.html',
  carrsqc:
    'https://carrsqc.onelink.me/TBVv?af_web_dp=http://www.carrsqc.com/health.html',
  haggen:
    'https://haggen.onelink.me/kuEK?af_web_dp=http://www.haggen.com/health.html',
  jewelosco:
    'https://jewelosco.onelink.me/tfDt?af_web_dp=http://www.jewelosco.com/health.html',
  pavilions:
    'https://pavilions.onelink.me/WHIR?af_web_dp=http://www.pavilions.com/health.html',
  randalls:
    'https://randalls.onelink.me/H77t?af_web_dp=http://www.randalls.com/health.html',
  safeway:
    'https://safeway.onelink.me/kO9l?af_web_dp=http://www.safeway.com/health.html',
  paknsave:
    'https://safeway.onelink.me/kO9l?af_web_dp=http://www.safeway.com/health.html',
  shaws:
    'https://shaws.onelink.me/clvH?af_web_dp=http://www.shaws.com/health.html',
  starmarket:
    'https://starmarket.onelink.me/PRuZ?af_web_dp=http://www.starmarket.com/health.html',
  tomthumb:
    'https://tomthumb.onelink.me/wBO4?af_web_dp=http://www.tomthumb.com/health.html',
  vons: 'https://vons.onelink.me/MuHG?af_web_dp=http://www.vons.com/health.html',
  albertsonsmarket:
    'https://albertsonsmarket.page.link/?link=http://www.albertsonsmarket.com/sincerelyhealth&apn=com.united.albertsonsrs&ibi=com.united.albertsonsrs&isi=1447354775&efr=1',
  amigosunited:
    'https://amigosunited.page.link/?link=https://www.amigosunited.com/sincerelyhealth&apn=com.united.amigosrs&ibi=com.united.amigosrs&isi=1447089065&efr=1',
  marketstreetunited:
    'https://marketstreetunited.page.link/?link=http://www.marketstreet.com/sincerelyhealth&apn=com.united.marketstreetrs&ibi=com.united.marketstreetrs&isi=1447354931&efr=1',
  unitedsupermarkets:
    'https://unitedsupermarkets.page.link/?link=http://www.unitedsupermarkets.com/sincerelyhealth&apn=sysnify.com.dfwrelationshop&ibi=sysnify.com.dfwrelationshop&isi=528178518&efr=1',
};

export {
  errorData,
  bannerObj,
  incentivePageHeading,
  uniqueOfferIds,
  govFundedOptions,
  hipaaConsentOptions,
  HIPAA_DECLINE,
  hipaaDeclineNotification,
  appDownloadLinks,
};
